import { showErrorMessage } from "../commons/show-error-message";
import { logError } from "../../infrastructure/log";
import { translate as t } from "../../infrastructure/translate/localization";
import { adaptDataToCsv } from "../../infrastructure/adapters/adaptDataToCsv";
import generateCsv from "../../services/generateCsv";

export async function downloadMovements({ movements }) {
  try {
    const title = "movements";
    const { headers, rows } = adaptDataToCsv({
      type: "movements",
      data: movements,
    });
    await generateCsv({
      title,
      headers,
      rows,
      messageLog: "downloadMovements",
    });
  } catch (e) {
    logError(e, `Error downloading movements`);
    showErrorMessage(t("common-messages.basic-error-message"), true);
  }
}
